import React, { useMemo, useState } from "react";
import { Button, Card, Typography } from "antd";
const { Title, Text } = Typography;

const keys = ["1","2","3","4","5","6","7","8","9","del","0","ok"] as const;

export default function PinPad({ onSubmit }: { onSubmit(pin: string): Promise<void> }) {
  const [pin,setPin]=useState("");
  const masked = useMemo(()=> (pin ? "•".repeat(pin.length) : "—"),[pin]);
  const press=(k:(typeof keys)[number])=>{
    if(k==="del") setPin(v=>v.slice(0,-1));
    else if(k==="ok") onSubmit(pin).then(()=>setPin("")).catch(()=>setPin(""));
    else setPin(v=>(v+k).slice(0,10));
  };
  return (
    <div style={{ width: 360 ,zIndex:1000}}>
      <Title level={3} style={{ marginBottom: 8,textAlign:'center' }}>Unesi PIN</Title>
      <Card style={{ textAlign:"center", marginBottom: 12 }}>
        <Text style={{ fontSize: 28, letterSpacing: 6 }}>{masked}</Text>
      </Card>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8 }}>
        {keys.map((k)=>(
          <Button key={k} onClick={()=>press(k)} size="large" style={{ height: 64, fontSize: 22, borderRadius: 14 }}
            type={k==="ok"?"primary":k==="del"?"primary":"default"} danger={k==="del"}>
            {k==="del"?"⌫":k.toUpperCase()}
          </Button>
        ))}
      </div>
    </div>
  );
}
